import { render, staticRenderFns } from "./VerifyVerificationCode.vue?vue&type=template&id=948e4ea4"
import script from "./VerifyVerificationCode.vue?vue&type=script&lang=js"
export * from "./VerifyVerificationCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports